import { defineStore } from "pinia";
import { http } from "./https";

export const useRecentGamesStore = defineStore("recent-games", {
  state: () => ({
    games: [],
    nextPage: 1,
  }),
  actions: {
    async loadRecentViews() {
      try {
        if(this.nextPage == null){
          return;
        }
        const response = await http.get(`/games/recent?page=`+this.nextPage);
        const data = response.data;

        this.nextPage = data.next_page_number;
        this.games = this.games.concat(data.games);

        return true;
      } catch (error) {
        console.error(error);
      }
      return false;
    },
  },
});
